import { useState } from "react";
import CustomTable from "../CustomTable/CustomTable";

const CustomersAiTable = () => {
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const columns = [
    {
      title: "Список созданных AI-ассистентов",
      dataIndex: "assistantList",
      key: "assistantList",
      align: "center",
    },
    {
      title: "Дата создания",
      dataIndex: "creationDate",
      key: "creationDate",
      align: "center",
    },
    {
      title: "Текущий статус",
      dataIndex: "status",
      key: "status",
      align: "center",
    },
    {
      title: "Количество запросов",
      dataIndex: "requestsCount",
      key: "requestsCount",
      align: "center",
    },
    {
      title: "Подключенные интеграции",
      dataIndex: "integrations",
      key: "integrations",
      align: "center",
    },
  ];

  const mockData = Array.from({ length: 12 }, (_, i) => ({
    key: i,
    assistantList: `Ассистент ${i + 1}`,
    creationDate: `2024-03-${String(i + 1).padStart(2, "0")}`,
    status: i % 3 === 0 ? "Активен" : i % 3 === 1 ? "Отключён" : "Удалён",
    requestsCount: Math.floor(Math.random() * 1000),
    integrations: i % 2 === 0 ? "Telegram" : "None",
  }));

  return <CustomTable columns={columns} mockData={mockData} />;
};

export default CustomersAiTable;
